import React from "react";

// Minimal, stroke-only SVG icon set. No emoji, no external deps.
// Usage: <IconGlobe className="..." />
// All icons inherit `currentColor` from their parent.

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const IconGlobe = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3c3 3 3 15 0 18" />
    <path d="M12 3c-3 3-3 15 0 18" />
  </svg>
);

export const IconTelegram = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M21.6 3.5 2.9 10.8c-1.1.4-1.1 1.1-.2 1.4l4.6 1.4 1.8 5.6c.2.6.1.9.7.9.5 0 .7-.2 1-.5l2.2-2.1 4.6 3.4c.9.5 1.5.2 1.7-.8L22.9 5c.3-1.3-.4-1.9-1.3-1.5ZM8.5 14.6l10.2-6.5-8.4 7.6v3.8l-1.8-4.9Z"/>
  </svg>
);

export const IconX = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231L18.244 2.25Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z"/>
  </svg>
);

export const IconGithub = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M12 2C6.48 2 2 6.58 2 12.24c0 4.53 2.87 8.36 6.84 9.72.5.1.68-.22.68-.49 0-.24-.01-.88-.01-1.72-2.78.62-3.37-1.36-3.37-1.36-.45-1.18-1.11-1.49-1.11-1.49-.91-.63.07-.62.07-.62 1 .07 1.53 1.05 1.53 1.05.89 1.56 2.34 1.11 2.91.85.09-.66.35-1.11.63-1.37-2.22-.26-4.56-1.14-4.56-5.07 0-1.12.39-2.03 1.03-2.75-.1-.26-.45-1.3.1-2.71 0 0 .84-.27 2.75 1.05A9.3 9.3 0 0 1 12 7.17c.85.004 1.71.12 2.51.34 1.91-1.32 2.75-1.05 2.75-1.05.55 1.41.2 2.45.1 2.71.64.72 1.03 1.63 1.03 2.75 0 3.94-2.35 4.81-4.58 5.07.36.32.68.95.68 1.92 0 1.39-.01 2.51-.01 2.85 0 .28.18.6.69.49C19.14 20.6 22 16.77 22 12.24 22 6.58 17.52 2 12 2Z"/>
  </svg>
);

export const IconCopy = (p) => (
  <svg {...base} {...p}>
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1" />
  </svg>
);

export const IconShare = (p) => (
  <svg {...base} {...p}>
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <polyline points="16 6 12 2 8 6" />
    <line x1="12" y1="2" x2="12" y2="15" />
  </svg>
);

export const IconArrowUpRight = (p) => (
  <svg {...base} {...p}>
    <path d="M7 17 17 7" />
    <path d="M8 7h9v9" />
  </svg>
);

export const IconBolt = (p) => (
  <svg {...base} {...p}>
    <path d="M13 3 4 14h7l-1 7 9-11h-7l1-7Z" />
  </svg>
);

export const IconFlame = (p) => (
  <svg {...base} {...p}>
    <path d="M12 3s4 3.5 4 8.5-2.5 7.5-5 7.5-5-2.5-5-7c0-2 1-3.5 2-4.5-.3 1.7.5 3 1.7 3.5C9 10 10 7 12 3Z" />
  </svg>
);

export const IconClock = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const IconUsers = (p) => (
  <svg {...base} {...p}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M15 14c3 0 6 2 6 5" />
  </svg>
);

export const IconChart = (p) => (
  <svg {...base} {...p}>
    <path d="M3 20h18" />
    <path d="M6 16v-5" />
    <path d="M11 16V6" />
    <path d="M16 16v-8" />
    <path d="M21 16v-3" />
  </svg>
);

export const IconCheck = (p) => (
  <svg {...base} {...p}>
    <path d="m5 12 4.5 4.5L20 6" />
  </svg>
);

export const IconRocket = (p) => (
  <svg {...base} {...p}>
    <path d="M14 3s5 0 7 2 2 7 2 7-4-1-6-3-3-6-3-6Z" />
    <path d="M9 15a4 4 0 1 0-4-4" />
    <path d="m14 9-8 8" />
    <path d="M6 14c-1.5 1.5-2 5-2 5s3.5-.5 5-2" />
  </svg>
);

export const IconCoins = (p) => (
  <svg {...base} {...p}>
    <ellipse cx="8" cy="7" rx="6" ry="3" />
    <path d="M2 7v5c0 1.7 2.7 3 6 3s6-1.3 6-3V7" />
    <path d="M14 10c2.7.3 8 1.5 8 4v3c0 1.7-2.7 3-6 3-1 0-2-.1-2.8-.3" />
    <path d="M2 12v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-2" />
  </svg>
);

export const IconChevronDown = (p) => (
  <svg {...base} {...p}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export const IconChevronLeft = (p) => (
  <svg {...base} {...p}>
    <path d="m15 18-6-6 6-6" />
  </svg>
);

export const IconEdit = (p) => (
  <svg {...base} {...p}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </svg>
);
